import React, {useEffect} from 'react';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import {labels} from '../../../util/utils';
import styled, {ThemeProvider} from 'styled-components';
import theme from '@ey/styled-theme';
import {navigationIcClose24px, contentIcAddCircle24px} from '@ey/motif-react-wrapper/assets/icons';
import ReactDOM from 'react-dom';
import {toolTipNames} from '../../../util/uiconstants';

const RemoveEngagementTooltip = (props) => {
	const onCloseHandler = (e) => {};

	const onDeleteHandler = (e, engagementIdToRemove, selectedNodeId) => {
		let updatedNodes = props.nodes.map((n) => {
			if (n.id.toString() === selectedNodeId) {
				let connectedEngagementsCount = n.engagements.length - 1;
				let x = {
					...n,
					engagements: n.engagements.filter((x) => x !== engagementIdToRemove),
					engagementLabel: labels.connectedToEngagements(connectedEngagementsCount)
				};

				return x;
			}
			return n;
		});

		props.setNodes(updatedNodes);
		// Reset the selection of engagements.
		props.setSelectedEngagements([]);

		ReactDOM.render(
			<ThemeProvider theme={theme}>
				<StyledRemoveEngagementTooltip
					entityName={updatedNodes.filter((n) => n.id.toString() === selectedNodeId)[0].entityName}
					nodeId={props.nodeId}
					engagements={updatedNodes.filter((n) => n.id.toString() === selectedNodeId)[0].engagements}
					allEngagements={props.allEngagements}
					nodes={updatedNodes}
					setNodes={props.setNodes}
					setSelectedEngagements={props.setSelectedEngagements}
				/>
			</ThemeProvider>,
			document.querySelector('#custom-tooltip-step3')
		);

		setTimeout(function() {
			var btns = document.querySelectorAll('#closeTooltip-engagement');
			for (var i = 0; i < btns.length; i++) {
				btns[i].addEventListener('click', function(e) {
					var tooltip = document.getElementById('tooltip-step3');
					tooltip.classList.remove('visible');
				});
			}
		}, 0);
	};

	const getEngagementsToDisplay = () => {
		let engagementList = []
		if(props.allEngagements) {
			engagementList = props.allEngagements.filter((x) => props.engagements.has(x.canvasEngagementId))
		}
		let engagementsNotAvailable = []
		
		if(props.engagements.length > engagementList.length ) {
			engagementsNotAvailable = _.difference(props.engagements, engagementList.map(e => e.canvasEngagementId))
			//props.engagements.filter((e) => !_.some(engagementList, 'canvasEngagementId', e))
		}
		if(_.isEmpty(engagementList)) {
			engagementsNotAvailable = [...props.engagements]
		}
		if(!_.isEmpty(engagementsNotAvailable)) {
			engagementsNotAvailable.map((eng) => {
				engagementList.push({canvasEngagementId: eng, engagementDescription: labels.notAvailable})
			})
		}

		return engagementList;
	}

	return (
		<StyledRemoveEngagementTooltip className="remove-eng-tooltip">
			<section className="header">
				<h3>
					<span title={props.entityName} className="header-text ellipsis">
						{props.entityName}
					</span>
					<span className="badge-count">{props.engagements.length}</span>
				</h3>
				<MotifIcon title={labels.closeLabel} id="closeTooltip-engagement" onClick={onCloseHandler} src={navigationIcClose24px} />
			</section>
			<section className={`${_.size(props.engagements) === 0 ? 'default-message tooltip-main' : 'tooltip-main'}`}>
				<section className="tooltip-body customScrollbar">
					{_.size(props.engagements) > 0 ? (
						<>
							{
								getEngagementsToDisplay().sort(function(a, b) {
									return a.engagementDescription.localeCompare(b.engagementDescription);
								})
								.map((engagement) => {
									return (
										<section className="eng-row">
											<span className="eng-col">
												<span className="eng-wrap">
													<span title={engagement.engagementDescription} className="eng-name ellipsis">
														{engagement.engagementDescription}
													</span>
													<span className="id-label ellipsis">{toolTipNames.Id}</span>
													<span title={engagement.canvasEngagementId} className="eng-id ellipsis">
														{engagement.canvasEngagementId}
													</span>
												</span>
												{engagement.clientEngagementName && engagement.clientEngagementCode &&
												<span className="client-wrap">
													<span title={engagement.clientEngagementName} className="client-name ellipsis">
														{engagement.clientEngagementName} 
													</span>	
													<span className="code-label ellipsis">{toolTipNames.Code}</span>													
													<span title={engagement.clientEngagementCode} className="client-code ellipsis">
														{engagement.clientEngagementCode}
													</span>
												</span>
												}
											</span>
											{!props.disableRemove && <MotifIcon
												id=""
												className="clear-row"
												onClick={(e) => onDeleteHandler(e, engagement.canvasEngagementId, props.nodeId)}
												src={contentIcAddCircle24px}
												title={labels.remove}
											/>}
										</section>
									);
								})}
						</>
					) : (
						<span title={labels.connectToAnEngagement} className="placeholder-message ellipsis">
							{labels.connectToAnEngagement}
						</span>
					)}
				</section>
			</section>
		</StyledRemoveEngagementTooltip>
	);
};
export default RemoveEngagementTooltip;

const StyledRemoveEngagementTooltip = styled.section`
	display: flex;
	flex-direction: column;
	height: 100%;

	.header {
		width: 100%;
		background-color: ${(props) => props.theme.color[`grey100`]};
		border-bottom: solid 1px ${(props) => props.theme.color[`grey300`]};
		padding: 0.5rem 1rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
		h3 {
			font-size: 1.3rem;
			margin: 0;
			display: flex;
			align-items: center;
			line-height: normal;
			font-weight: bold;
			max-width: 82%;			
			.header-text {
				display: inline-block;
				width: 100%;
				margin-right: 1rem;
				color: ${(props) => props.theme.color[`black`]};
			}
		}
		.badge-count {
			background-color: ${(props) => props.theme.color[`grey500`]};
			color: ${(props) => props.theme.color[`white`]};
			font-size: 1rem;
			padding: 0.2rem 0.5rem;
			border-radius: 50%;
		}
		.motif-icon,
		svg {
			width: 2rem !important;
			height: 2rem !important;
		}
	}

	.tooltip-main {
		flex: 1;
		overflow: auto;

		&.default-message {
			font-size: 1.2rem;
			.tooltip-body {
				padding: 1rem;
				align-items: center;
				justify-content: center;
				.placeholder-message {
					width: 99%;
					display: inline-block;
					font-weight: 300;
					color: ${(props) => props.theme.color[`grey400`]};
					text-align: center;
				}
			}
		}
	}

	.tooltip-body {
		display: flex;
		flex-direction: column;
		width: 100%;
		flex: 1;
		overflow: auto;
		min-height: 15rem;
		max-height: 15rem;
		.eng-row {
			padding: 0 1rem 0.5rem 1rem;
			display: flex;
			justify-content: space-between;
			align-items: center;

			&:first-child {
				padding-top: 1rem;
			}
			.clear-row {
				transform: rotate(135deg);
				display: inline-block;
				width: 2rem;
				height: 2rem;
				svg {
					max-width: 2rem;
					max-height: 2rem;
					fill: ${(props) => props.theme.color[`black`]};
				}
			}
			.eng-col {
				display: flex;
				flex-direction: column;
				width: 90%;
			}

			.eng-wrap,
			.client-wrap {
				width: 100%;
				display: flex;
				font-size: 1.2rem;
			}
			.eng-wrap {
				font-weight: bold;
			}

			.eng-name,
			.client-name {
				display: inline-block;
				max-width: 50%;
				margin-right: 0.5rem;
			}
			.id-label,
			.code-label{
				max-width: 20%;
			}
			.eng-id,
			.client-code {
				margin-left: 0.5rem;
				display: inline-block;
				width: 30%;
			}

			.client-code,
			.client-name {
				font-size: 1.1rem;
				font-weight: 300;
			}
		}
	}

	.ellipsis {
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}
`;
